/* unplugin-vue-components disabled */import { render } from "./share-modal.vue?vue&type=template&id=d3d8bbe2&scoped=true"
import script from "./share-modal.vue?vue&type=script&lang=js"
export * from "./share-modal.vue?vue&type=script&lang=js"

import "./share-modal.vue?vue&type=style&index=0&id=d3d8bbe2&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3d8bbe2"],['__file',"src/pages/chats/chat-sharing/share-modal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d3d8bbe2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d3d8bbe2', __exports__)) {
    api.reload('d3d8bbe2', __exports__)
  }
  
  module.hot.accept("./share-modal.vue?vue&type=template&id=d3d8bbe2&scoped=true", () => {
    api.rerender('d3d8bbe2', render)
  })

}


export default __exports__